import { useRouter } from 'next/router';
import React from 'react';

export default function WalletPageComponent() {
  const router = useRouter();
  const customerId = router.query.id as string;

  React.useEffect(() => {
    if (customerId) {
      router.replace(`/wallets/${customerId}/redeemed`);
    }
  }, [customerId, router]);

  return null;
}
